import { Language } from './enums/languages';
import { LOCAL_STORAGE_USER_LOCALE } from './store';

export const CURRENT_LANGUAGE: Language =
  (sessionStorage
    .getItem(LOCAL_STORAGE_USER_LOCALE)
    ?.replaceAll('"', '') as Language) || Language.EN;
